// 需要登录的页面可以使用  middleware: "authenticated", 来表面此页面需要登录
export default function ({ store, error }) {
  const isLogin = !!store.state.user.isLogin;
  if (!isLogin) {
    error({
      statusCode: 403,
      message: {
        title: '请先登录再进行操作！',
        desc: '可能原因：1、系统繁忙；2、网络链接失败；3、未登录；',
      },
    });
  }
}
